module.exports = __webpack_public_path__ + "static/media/vanities.5f39a14c.JPG";